import React from "react";
import {
  Dialog,
  DialogBody,
} from "@material-tailwind/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
 
import { faEye  } from '@fortawesome/free-solid-svg-icons';
import { Button,Modal } from "antd";

export function DialogWithImage(props) {
const {data}=props;

  const [open, setOpen] = React.useState(false);
  const [isFavorite, setIsFavorite] = React.useState(false);
 
  const handleOpen = () => setOpen((cur) => !cur);
  const handleIsFavorite = () => setIsFavorite((cur) => !cur);
 
  return (
    <>
   
        <Button     onClick={handleOpen} style={{ marginRight: '10px' }}>
  <FontAwesomeIcon icon={faEye} style={{ color: "#ccc", marginRight: "10px" }} />
  View
</Button>

      <Dialog size="xs" open={open} handler={handleOpen}>
        <DialogBody divider={true} className="p-0">
          <div className="flex w-full justify-center">
            <div className="w-full border-2 p-3" >
       <h1 className="text-2xl text-center" style={{background:" #095156",color:"white"}} >Payment Information</h1>
      <br /><br />
       <h1 className="font-bold" > <span className="text-black" > Name : </span> <span> {data.name} </span></h1>
       <h1 className="font-bold" > <span className="text-black" > Roll Number : </span> <span> {data.rollnumber} </span></h1>
       <h1 className="font-bold" > <span className="text-black" > Phone Number : </span> <span> {data.phone} </span></h1>
<br />      
       <img
            alt="nature"
            className="h-[35rem] w-full "
            src={data.pic}
            />
          
            </div>

           
       



            </div>
           
  
        </DialogBody>
      
      </Dialog>
    </>
  );
}